import ApiService from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModel from "../../commons/base/view_model";

export interface OutletCompletionResponse {
    ruko: OutletCompletionInfoModel[];
    booth: OutletCompletionInfoModel[];
    shack: OutletCompletionInfoModel[];
    specialShack: OutletCompletionInfoModel[];
}

export interface OutletCompletionInfoModel {
    outlet_name: string;
    kitchen_record_qty: string;
    driver_record_qty: string;
    max_time: string;
    to_customer: string;
    max_cooking_time: string;
}

export class CompletionState {
    errorMessage: string = "";
    partitionedRukoData: OutletCompletionInfoModel[][] = [];
    partitionedBoothData: OutletCompletionInfoModel[][] = [];
    partitionedShackData: OutletCompletionInfoModel[][] = [];
    partitionedShackSpecialData: OutletCompletionInfoModel[][] = [];

    rukoData: OutletCompletionInfoModel[] = [];
    shackFirstHalfData: OutletCompletionInfoModel[] = [];
    shackSecondHalfData: OutletCompletionInfoModel[] = [];
    shackSpecialData: OutletCompletionInfoModel[] = [];

    get isLoading() {
        return !(this.rukoData.length !== 0 ||
            this.shackFirstHalfData.length !== 0 ||
            this.shackSecondHalfData.length !== 0 ||
            this.shackSpecialData.length !== 0);
    }
}

export default class CompletionViewModel extends ViewModel<CompletionState> {
    constructor() {
        super(new CompletionState());
        this.loadContent();
    }

    loadContent() {
        ApiService.fetch<{}, BaseResponse<OutletCompletionResponse>>(
            Endpoints.completionInfo,
            {
                onSuccess: (response) => {
                    const data = response.data as OutletCompletionResponse;

                    const {
                        booth: boothData,
                        ruko: rukoData,
                        shack: shackData,
                        specialShack,
                    } = data;

                    const partitionedShackData = this.partitionData({
                        data: shackData,
                        numberOfTables: 2,
                    });

                    this.emit((state) => {
                        state.rukoData = rukoData;
                        state.shackFirstHalfData = partitionedShackData[0];
                        state.shackSecondHalfData = partitionedShackData[1];
                        state.shackSpecialData = specialShack;
                    });

                    setTimeout(() => this.loadContent(), 20000);
                },
                onFailure: (error, errorCode) => {
                    console.log("Error Code : ", errorCode);
                    console.log("Error Message : ", error);
                    this.emit((state) => {
                        state.errorMessage =
                            "Koneksi internet sempat terganggu, silakan coba refresh halaman ini!";
                    });
                },
            }
        );
    }

    partitionData(args: {
        data: OutletCompletionInfoModel[];
        numberOfTables: number;
    }) {
        const { data, numberOfTables } = args;
        const result: OutletCompletionInfoModel[][] = [];

        const partitionLength = Math.ceil(data.length / numberOfTables);
        let startIndex = 0;

        while (result.length !== numberOfTables) {
            const partitionedData = data.slice(
                startIndex,
                startIndex + partitionLength
            );
            result.push(partitionedData);
            startIndex += partitionLength;
        }

        return result;
    }
}
